import { Typography } from '@gds/Typography/Typography';

import styles from './GuaranteeModal.module.css';

export const GuaranteeModal = ({
  content,
  messages,
}: {
  content: string[];
  messages: Record<string, string>;
}) => {
  return (
    <div className={styles.contentWrapper}>
      <Typography variant="h6">{messages.guaranteeTitle}</Typography>
      <Typography variant="body4">
        <ul className={styles.guaranteesList}>
          {content.map((item: string, idx: number) => (
            <li key={idx}>
              <Typography variant="body4">{item}</Typography>
            </li>
          ))}
        </ul>
      </Typography>
      <Typography variant="body4">{messages.guaranteeCondition}</Typography>
    </div>
  );
};
